import React, { useCallback, useEffect, useMemo } from 'react'
import cx from 'classnames'
import { l } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import * as billingActions from 'common/billing/actions/billingActions'
import { getBillingState } from 'common/billing/entities/miscellaneous/selectors'
import { ProInfoProductV3 } from 'common/billing/entities/pro/interfaces'
import { getActiveProduct } from 'common/billing/entities/pro/selectors'
import { getScheduledSubscriptionChangeData } from 'common/billing/entities/subscription/selectors'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const PlanDowngradeNotification = () => {
  const dispatch = useAppDispatch()
  const scheduledPlanChangeData = useAppSelector(getScheduledSubscriptionChangeData)
  const activeProduct = useAppSelector(getActiveProduct) as Nullable<ProInfoProductV3>
  const { fetchingCancelScheduledChangePlan } = useAppSelector(getBillingState)

  const handleStayOnCurrentPlan = useCallback(() => {
    if (fetchingCancelScheduledChangePlan) return

    analyticsService.sendEvent('NOTIFICATION_BAR.BILLING.CANCEL_SCHEDULED_PLAN.CLICKED')
    dispatch(billingActions.cancelScheduledChangePlan())
  }, [dispatch, fetchingCancelScheduledChangePlan])

  useEffect(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.BILLING.CANCEL_SCHEDULED_PLAN.SHOWN')
  }, [])

  const infoText = useMemo(() => {
    if (!scheduledPlanChangeData) return ''

    if (scheduledPlanChangeData.monthsLeft) {
      return l.translate(
        'Plan will downgrade to {nextPlanTitle} in {monthsLeft, plural, one {# month} other {# months}}, you will lose some features',
        {
          nextPlanTitle: scheduledPlanChangeData.plan.name,
          monthsLeft: scheduledPlanChangeData.monthsLeft,
        },
      )
    }

    return l.translate(
      'Plan will downgrade to {nextPlanTitle} in {daysLeft, plural, one {# day} other {# days}}, you will lose some features',
      {
        nextPlanTitle: scheduledPlanChangeData.plan.name,
        daysLeft: scheduledPlanChangeData.daysLeft,
      },
    )
  }, [scheduledPlanChangeData])

  return (
    <div className="d-flex align-center">
      <span>{infoText}</span>
      <span
        className={cx(cm.readMore, 'm-l-xs', {
          'text-default c-not-allowed': fetchingCancelScheduledChangePlan,
        })}
        onClick={handleStayOnCurrentPlan}
      >
        {l.translate('Stay in {activeProduct}', { activeProduct: activeProduct?.name })}
      </span>
    </div>
  )
}
